window.onload = () => {
  const grid = document.querySelector('.instafeed-grid');
  const firstChild = document.querySelector('.instafeed-grid > .instafeed-grid__item:first-child');
  const secondChild = document.querySelector('.instafeed-grid > .instafeed-grid__item:nth-child(2)');

  if (grid && firstChild && secondChild) {
    const gridWidth = grid.offsetWidth;
    const firstChildWidth = firstChild.offsetWidth;
    const remainingWidth = gridWidth - firstChildWidth;

    secondChild.style.setProperty('--width', remainingWidth - (10.93 * 2) + 'px'); // Apply remaining width to the second child
  }
};